import { useState } from "react";
import { useTranslation } from "react-i18next";
import CountrySelect from "../document_upload/CountrySelect";
import ProofOfResidenceTypeSelect from "./ProofOfResidenceTypeSelect";
import ProofOfResidenceUpload from "./ProofOfResidenceUpload";
import { trackEvent } from "../../../utils/analytics";

function ProofOfResidence({ verification, inputChange }) {
  const { t } = useTranslation();
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedDocType, setSelectedDocType] = useState(null);

  const handleCountrySelect = (country) => {
    const countryJson = JSON.parse(country);
    trackEvent("proof_of_residence_country_selected", {
      flowId: verification?.flowId,
      verificationId: verification?.verificationId,
      country: countryJson?.code,
    });
    setSelectedCountry(countryJson);
  };

  const handleUploadComplete = (uploadData) => {
    inputChange([uploadData]);
  };

  if (!selectedCountry) {
    return (
      <CountrySelect
        onSelect={handleCountrySelect}
        heading={t("proofOfResidence.countrySelect.heading")}
        subheading={t("proofOfResidence.countrySelect.subheading")}
      />
    );
  }

  if (!selectedDocType) {
    return <ProofOfResidenceTypeSelect onSelect={setSelectedDocType} />;
  }

  return (
    <ProofOfResidenceUpload
      docType={selectedDocType}
      country={selectedCountry}
      goback={() => setSelectedDocType(null)}
      inputChange={handleUploadComplete}
      verification={verification}
    />
  );
}

export default ProofOfResidence;
